<script lang="ts">
    import {Component} from 'vue-facing-decorator'
    import {ProductBookingFieldsMixin} from '@/components/booking/mixins/ProductBookingFieldsMixin.vue'

    @Component
    export class ActivityBookingFieldsMixin extends ProductBookingFieldsMixin {
        filterPrepareBookRequest(prepareBookRequest) {
            if (!prepareBookRequest.startTime) {
                delete prepareBookRequest.startTime
            }
            if (this.isProductFieldDisabled('PICK_UP_PLACE') || !prepareBookRequest.pickUpPlace)
                delete prepareBookRequest.pickUpPlace
            if (this.isProductFieldDisabled('PICK_UP_HOTEL') || !prepareBookRequest.hotelPointKey)
                delete prepareBookRequest.hotelPointKey
            return prepareBookRequest
        }
    }

    export default ActivityBookingFieldsMixin
</script>
